import Fetch from "../../components/fetch";

export default class Chapters {
	constructor() {
		this.api = new Fetch;
	}

	async getChapter(book, verse, search = false) {
		const params = this.api.buildQueryParamns({
			search: search
		});

		return await this.api.send(`chapter/${book}_${verse}/${params}`);
	}
}
